$(function() {

	$('body').on('click', 'a[href^="#"]', function() {
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - $("header").outerHeight();
	 	$("html, body").animate({scrollTop:position}, 550, "swing");
	    return false;
	});

	//SPメニュー
	var currentScroll = 0;
	$('body').on('click', '.js-trigger', function() {
		if ( $('.js-menu').hasClass('is-open') ) {
			$('body').removeClass('is-open');
			$('.js-trigger').removeClass('is-open');
			$('.js-menu').removeClass('is-open');
			window.scrollTo( 0 , currentScroll );

		} else {
			currentScroll = $(window).scrollTop();
			
			$('.js-trigger').addClass('is-open');
			$('.js-menu').addClass('is-open');
			$('body').addClass('is-open');
			$('body').css({
			  top: -1 * currentScroll
			});
			
		
		}
	});		

	//動く
	$(window).scroll(function() {
		var elem = $('.js-move');
		elem.each(function () {
			var elemOffset = $(this).offset().top;
			var scrollPos = $(window).scrollTop();
			var wh = $(window).height();

			if(scrollPos > elemOffset - wh + (wh / 6) ){
			  $(this).addClass("is-active");
			}
		});

	});
		
})
